import { Link } from 'react-router-dom';

export default function Brand() {
  return (
    <Link className="brand" to="/">
      <img src="/logo-wordmark.webp" alt="NorthBridge One" width={724} height={120} />
    </Link>
  );
}
